import { Box, Button, Card, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import GlobalInput from '../form/FreeFormInput'
import { profileInfoCardStyles } from '../../styles/classes/CompanySettingsClasses'
import { conformToMask } from 'react-text-mask'
import { userHasAuthorization } from '../../services/AuthService'

const EditButton = props => {
  const { classes } = profileInfoCardStyles()
  return (
    <Button
      data-testid="edit_company_info_button"
      className={classes.editButton}
      onClick={props.onClick}
    >
      {props.label}
    </Button>
  )
}

export const ProfileInfoCard = props => {
  const { classes } = profileInfoCardStyles()
  const { t } = useTranslation()

  const handleEditProfile = () => {
    props.setComponent('profile')
    props.setOpen(true)
  }

  const maskValue = value => {
    if (value) {
      const result = conformToMask(
        value,
        [
          '(',
          /[1-9]/,
          /\d/,
          /\d/,
          ')',
          ' ',
          /\d/,
          /\d/,
          /\d/,
          ' ',
          /\d/,
          /\d/,
          /\d/,
          /\d/
        ],
        { guide: false }
      )
      return result.conformedValue
    } else {
      return ''
    }
  }

  return (
    <Card data-testid="profile_info_card" className={classes.card}>
      <Box display="flex" flexDirection="row">
        <Typography classes={{ root: classes.cardTitle }}>
          {t('company_settings.card.profile')}
        </Typography>
        {userHasAuthorization('company_settings:write') && (
          <EditButton
            label={t('company_settings.buttons.edit')}
            onClick={handleEditProfile}
          />
        )}
      </Box>
      <Box className={classes.marginContainer}>
        <Box flex={2}>
          <GlobalInput
            field="name"
            value={props?.profile?.name ?? ''}
            label={t('company_profile.labels.company_legal')}
            disabled
            className={classes.disabledText}
            placeholder={t('company_profile.labels.company_legal')}
          />
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          className={classes.boxContainer}
        >
          <Box flex={2}>
            <GlobalInput
              field="address"
              value={
                props?.profile?.address?.address?.length
                  ? props?.profile?.address?.address
                  : ''
              }
              label={t('company_profile.labels.address')}
              disabled
              className={classes.disabledText}
              placeholder={t('company_profile.labels.address')}
            />
          </Box>
        </Box>

        <Box
          display="flex"
          flexDirection="row"
          className={classes.boxContainer}
        >
          <Box
            flex={2}
            display="flex"
            flexDirection="row"
            className={classes.boxContainer}
          >
            <GlobalInput
              field="business_hours_phone"
              value={maskValue(props?.profile?.business_hours?.phone)}
              label={t('company_profile.labels.business_hours')}
              disabled
              className={classes.disabledText}
              placeholder={t('company_profile.labels.business_hours')}
            />
            <GlobalInput
              field="after_hours_phone"
              value={maskValue(props?.profile?.after_hours?.phone)}
              label={t('company_profile.labels.after_hours')}
              disabled
              className={classes.disabledText}
              placeholder={t('company_profile.labels.after_hours')}
            />
          </Box>
          <Box flex={0.5}></Box>
        </Box>

        <Box
          display="flex"
          flexDirection="row"
          className={classes.boxContainer}
        >
          <Box
            flex={2}
            display="flex"
            flexDirection="row"
            className={classes.boxContainer}
          >
            <GlobalInput
              field="businesshours_phone"
              value={props?.profile?.email ?? ''}
              label={t('company_profile.labels.email')}
              disabled
              className={classes.disabledText}
              placeholder={t('company_profile.labels.email')}
            />
            <GlobalInput
              field="company_website"
              value={props?.profile?.website ?? ''}
              label={t('company_profile.labels.company_website')}
              disabled
              className={classes.disabledText}
              placeholder={t('company_profile.labels.company_website')}
            />
          </Box>
          <Box flex={0.5}></Box>
        </Box>
      </Box>
    </Card>
  )
}
